import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=531e9f80&scoped=true&"
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e9f80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531e9f80')) {
      api.createRecord('531e9f80', component.options)
    } else {
      api.reload('531e9f80', component.options)
    }
    module.hot.accept("./rate.vue?vue&type=template&id=531e9f80&scoped=true&", function () {
      api.rerender('531e9f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/rate.vue"
export default component.exports